import { set, toggle } from '@/utils/vuex'

export default {
    namespaced: true,
    state: {
        drawer: null,
        color: 'success',
        image: ''
    },
    mutations: {
        setDrawer: set('drawer'),
        setImage: set('image'),
        setColor: set('color'),
        toggleDrawer: toggle('drawer')
    }
};
